var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group",attrs:{"id":_vm.groupId}},[_c('label',{staticClass:"form-label",attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.label))]),_c('input-number',{attrs:{"id":_vm.inputId,"value":_vm.value,"precision":_vm.precision,"disabled":_vm.disabled,"readonly":_vm.readonly},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }